import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "../cart/style/Cart.css";
import toast, { Toaster } from "react-hot-toast";
import "react-loading-skeleton/dist/skeleton.css";
import { Modal } from "react-bootstrap";
import { addToCart as apiAddToCart } from "../ProductDetail/service/productcart.service";
import { getCustomers } from "../cart/service/Customers.service";
import { persistCartContext } from "../checkout/service/cart.service";
import "../cart/style/customermodel.css";
import{ addToCart } from "../cart/redux/cartSlice";


function CartList({ sizes = [] }) {
  const dispatch = useDispatch(); 
  const [loadingId, setLoadingId] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [search, setSearch] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);


// ADD TO CART CLICK

const handleAddToCart = async (item) => {
  const quantity = quantities[item.product_id] ?? 1;

  if (selectedCustomer) {
    try {
      setLoadingId(item.product_id);

      const payload = {
        cart_type: "fresh",
        user_id: 1,
        customer_id: selectedCustomer,
        product_listing_id: item.product_listing_id || item.product_id,
        qty: quantity,
      };

      const res = await apiAddToCart(payload);

      if (res?.success) {
        persistCartContext({
          cartType: payload.cart_type,
          userId: payload.user_id,
          customerId: payload.customer_id,
        });

        toast.success("Added to Cart");

    const qty =
      quantities[selectedItem.product_id] || 1;
    dispatch(
      addToCart({
        ...selectedItem,
        quantity: qty,
        qty: qty,
      })
     )
      } else {
        toast.error(res?.message || "Failed");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoadingId(null);
    }

    return;
  }

  try {
    const res = await getCustomers(982);
    const list = res?.data || res?.customers || res || [];

    setCustomers(Array.isArray(list) ? list : []);
    setSelectedItem(item);
    setSearch("");
    setShowModal(true);

  } catch {
    toast.error("Unable to load customers");
  }
};

  // CUSTOMER SELECT
const handleCustomerSelect = async (customer) => {
  try {
    setSelectedCustomer(customer.id);
    setSearch(customer.accountName);
    setShowModal(false);

    const qty = quantities[selectedItem.product_id] ?? 1;

    const payload = {
      cart_type: "fresh",
      user_id: 1,
      customer_id: customer.id,
      product_listing_id:
        selectedItem.product_listing_id || selectedItem.product_id,
      qty,
    };

    setLoadingId(selectedItem.product_id);

    const res = await apiAddToCart(payload);

    if (res?.success) {
      // Save cart context
      persistCartContext({
        cartType: payload.cart_type,
        userId: payload.user_id,
        customerId: payload.customer_id,
      });

      // Save complete customer object
      localStorage.setItem(
        "selectedCustomer",
        JSON.stringify(customer)
      );

      dispatch(
        addToCart({
          ...selectedItem,
          quantity: qty,
          qty,
        })
      );

      toast.success("Added to Cart");
    } else {
      toast.error(res?.message || "Failed");
    }
  } catch (error) {
    toast.error("Something went wrong");
  } finally {
    setLoadingId(null);
  }
};
  return (
    <> 
    <div className="TableBoxcart">
      <Toaster position="top-right" reverseOrder={false} />

      <div className="table-responsive">
        <div className="table-box-content">
          <div className="table-header-fixed">
            <table className="table table-sm table-striped mb-0">
              <thead className="text-center">
                <tr>
                  <th>Size</th>
                  <th>Barcode</th>
                  <th>Shape</th>
                  <th>Stock</th>
                  <th>Ord. Qty</th>
                  <th>MRP</th>
                  <th>Cart</th>
                  <th>Wishlist</th>
                </tr>
              </thead>
            </table>
          </div>

          <div className="table-body-scroll">
            <table className="table table-sm table-striped mb-0">
              <tbody>
                {sizes.length > 0 ? (
                  sizes.map((item) => (
                    <tr key={item.product_id}>
                      <td>{item.size}</td>
                      <td>{item.barcode}</td>
                      <td>{item.shape}</td>
                      <td className="text-center">{item.avail_stock}</td>

                      <td className="text-center">
                        {/* <select
                            className="form-control form-control-sm select-List"
                            value={quantities[item.product_id] ?? 0}
                            onChange={(e) =>
                              setQuantities((prev) => ({
                                ...prev,
                                [item.product_id]: Number(e.target.value),
                              }))
                            }
                          >
                            {[...Array(11).keys()].map((i) => (
                              <option key={i} value={i+1}>
                                {i+1}
                              </option>
                            ))}
                            <option value="10+">10+</option>
                          </select> */}
                          <input
                                type="number"
                                className="form-control form-control-sm text-center select-List"
                                value={quantities[item.product_id] ?? 1}
                                min="1"
                                max={item.avail_stock}
                                onChange={(e) => {
                                  let qty = Number(e.target.value);

                                  if (qty < 1 || isNaN(qty)) {
                                    qty = 1;
                                  }

                                  if (qty > Number(item.avail_stock)) {
                                    qty = Number(item.avail_stock);
                                  }

                                  setQuantities((prev) => ({
                                    ...prev,
                                    [item.product_id]: qty,
                                  }));
                                }}
                              />
                      </td>

                      <td>{item.mrp}</td>

                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary addtocart"
                          onClick={() => handleAddToCart(item)}
                          disabled={loadingId === item.product_id}
                        >
                          <i className="bi bi-cart-plus"></i>
                        </button>
                      </td>

                      <td className="text-center">
                        <button
                          type="button"
                          className="btn btn-outline-secondary WishListbtn"
                          onClick={() => handleAddToCart(item)}
                          disabled={loadingId === item.product_id}
                        >
                          <i className="bi bi-heart"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-3">
                         No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

      {/* Customer Modal */}

<Modal
  show={showModal}
  onHide={() => {
    setShowModal(false);
    setSearch("");
    setCustomers([]);
    setSelectedCustomer(null);
  }}
  // backdrop="static"
  centered={false}
  dialogClassName="customer-modal-dialog"
  contentClassName="customer-modal-content"
>
  <Modal.Body className="p-0">
    <div className="position-relative p-3 ">
      <input
        type="text"
        className="form-control "
        placeholder="Search Customer..."
        autoFocus
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

    {search &&
  (Array.isArray(customers) ? customers : [])
    .filter((item) =>
      item.accountName?.toLowerCase().includes(search.toLowerCase())
    ).length > 0 && (
    <div
      className="list-group position-absolute w-100"
      style={{
        zIndex: 1000,
        maxHeight: "220px",
        overflowY: "auto",
        background: "#fff",
        border: "1px solid #ddd",
      }}
    >
      {(Array.isArray(customers) ? customers : [])
        .filter((item) =>
          item.accountName?.toLowerCase().includes(search.toLowerCase())
        )
        .map((customer) => (
          <button
            key={customer.id}
            type="button"
            className="list-group-item list-group-item-action text-start"
            onClick={() => handleCustomerSelect(customer)}
          >
            {customer.accountName}
            
          </button>
        ))}
    </div>
  )}
    </div>
  </Modal.Body>
</Modal>

 </>

  );
}
export default CartList;